<template>
  <div
    class="star-rating"
    v-if="parsedScore > 0 "
  >
    <i
      class="icon-star"
      v-for="n in parsedScore"
      :key="'active' + n"
    />
    <i
      class="icon-star inactive"
      v-for="i in inactiveCount"
      :key="'inactive' + i"
    />
  </div>
</template>

<script>
export default {
  name: 'StarRating',
  props: {
    score: {
      type: [Number, String],
      default: 0
    },
    limit: {
      type: Number,
      default: 5
    }
  },
  computed: {
    parsedScore () {
      return parseInt(this.score)
    },
    inactiveCount () {
      return this.limit - this.score
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/star-rating.vue